document.querySelectorAll('[id^="ExpandPalate-"]').forEach((grid) => {
  const sectionId = grid.id.replace('ExpandPalate-', '');
  const nextBtn = document.getElementById(`ExpandPalateNext-${sectionId}`);
  if (!nextBtn) return;

  const updateNavVisibility = () => {
    const maxScroll = grid.scrollWidth - grid.clientWidth;
    nextBtn.hidden = maxScroll <= 4 || grid.scrollLeft >= maxScroll - 4;
  };

  nextBtn.addEventListener('click', () => {
    const card = grid.querySelector('.expand-palate-card');
    const scrollAmount = card ? card.getBoundingClientRect().width + 24 : grid.clientWidth * 0.8;
    grid.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  });

  grid.addEventListener('scroll', updateNavVisibility, { passive: true });
  window.addEventListener('resize', updateNavVisibility);
  updateNavVisibility();
});